import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../../services/api";
import Constants from "../../../services/constants";
import { hideLoader, showLoader } from "../loaderSlice";
import { showToast } from "../toastSlice";

const initialState = {
  data: [],
  status: {},
};

export const getCustomDomainsAction = createAsyncThunk(
  "customDomain/get",
  async ({ projectId }, { dispatch }) => {
    try {
      const res = await api(
        "get",
        `${Constants.END_POINT.custom_domain}project/${projectId}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setDomainList(res?.data));
      } else {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject("An error occurred.");
    }
  }
);

export const verifyDomainStatusAction = createAsyncThunk(
  "customDomain/verify",
  async ({ id }, { dispatch }) => {
    try {
      const res = await api(
        "get",
        `${Constants.END_POINT.custom_domain}verify/${id}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setDomainStatus(res?.data));
      } else {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject("An error occurred.");
    }
  }
);

export const createCustomDomainAction = createAsyncThunk(
  "customDomain/create",
  async ({ data, next }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api("post", Constants.END_POINT.custom_domain, data);
      if (res?.success && res?.data) {
        dispatch(getCustomDomainsAction({ projectId: data.project_id }));
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(
        showToast({
          severity: "error",
          summary: error.message || "An error occurred.",
        })
      );
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const deleteCustomDomainAction = createAsyncThunk(
  "customDomain/delete",
  async ({ domain_id, next }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "delete",
        `${Constants.END_POINT.custom_domain}${domain_id}`
      );
      if (res?.success && res?.data) {
        next();
      } else {
        return Promise.reject(res.message);
      }
    } catch (error) {
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

const customDomainSlice = createSlice({
  name: "customdomain",
  initialState,
  reducers: {
    setDomainList: (state, action) => {
      state.data = action.payload;
    },
    setDomainStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

export const { setDomainList, setDomainStatus } = customDomainSlice.actions;

export default customDomainSlice.reducer;
